/*=========================================================================================
  File Name: moduleCompteState.js
  Description: Compte Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  comptes: []
}
  